import { Descriptions } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { showAlertAction } from "store/alert";
import { setOrgDashboardAction } from "store/org";
import { getUserAction } from "store/users";
import { getOrgStaffProfileOrgField } from "utils";
import { positionToOrgMapping2 } from "utils";
import { positionsMapping } from "utils";

const StaffProfile = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const orgType = positionToOrgMapping2[userData?.position];
  const orgIdField = getOrgStaffProfileOrgField(userData?.position);
  const orgFieldId =
    userData?.position === "CO" ? userData?.id : userData?.[orgIdField]?.id;

  useEffect(async () => {
    const staff = await dispatch(getUserAction(id));
    if (staff) {
      setUserData({ ...staff });
    }
  }, []);

  const handleDashboard = () => {
    dispatch(setOrgDashboardAction({ orgId: orgFieldId, type: orgType })).then(
      history.push(`/org/${orgType}/${orgFieldId}`)
    );
  };

  return (
    <div>
      <Descriptions title={userData?.name} layout="horizontal">
        <Descriptions.Item label="Last Login">
          {moment(userData?.last_login).format('LLLL')}
        </Descriptions.Item>
        <Descriptions.Item label="Position">
          {positionsMapping[userData?.position]}
        </Descriptions.Item>

        <Descriptions.Item label="Address">
          {userData?.address}
        </Descriptions.Item>

        <Descriptions.Item label="Phone Number">
          {userData?.phone_number}
        </Descriptions.Item>

        <Descriptions.Item label="Email">{userData?.email}</Descriptions.Item>
      </Descriptions>

      {userData?.position !== "DR" && (
        <strong>
          <div className="btn-link" role="button" onClick={handleDashboard}>
            View Dashboard <i className="fa fa-link" aria-hidden="true"></i>
          </div>
        </strong>
      )}
    </div>
  );
};

export { StaffProfile };
